import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import './Circle.css';

const sizes = {
  SMALL: 0,
  MEDIUM: 1,
};

class Circle extends React.Component {
  render() {
    const classes = cx({
      Circle: this.props.size === sizes.MEDIUM,
      CircleSmall: this.props.size === sizes.SMALL,
    });
    return <div className={classes} style={{...this.props.style}} />;
  }
}

Circle.defaultProps = {
  style: {},
  size: sizes.MEDIUM,
};

Circle.propTypes = {
  size: PropTypes.number.isRequired,
  style: PropTypes.object,
};

Circle.sizes = sizes;

export default Circle;
